import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import * as _ from 'lodash';

import {ErrorHandlerService} from '../../services/error-handler.service';
import {ProjectService} from '../../../projects/services/projects.service';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent implements OnInit {
  isUploading = false;

  @Input() types: string;
  @Input() labelClass: string;
  @Input() iconClass: string;
  @Input() icon: string;
  @Input() text: string;
  @Input() maxFileSize = 30;
  @Input() multiple = false;

  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() afterUpload: EventEmitter<string> = new EventEmitter();

  constructor(
    private projectService: ProjectService,
    private errorHandlerService: ErrorHandlerService,
  ) { }

  ngOnInit() {}

  onLoad(event: any) {
    const files: FileList = event.target.files && event.target.files;

    if (!files.length) {
      this.errorHandlerService.handle('No file to upload');
      event.stopPropagation();

      return;
    }

    _.map(files, (file: File) => {
      const ext = file.name.split('.').pop();
      const fileTypes = new RegExp(this.types.split(',').join('|'));

      if (!fileTypes.test(`.${ext.toLowerCase()}`)) {
        this.errorHandlerService.handle('File extension is not allowed');
        event.stopPropagation();

        return;
      }

      if (!this.afterUpload.observers.length) {
        this.change.emit(event);

        return;
      }

      this.uploadFile(file);
    });
  }

  uploadFile(file: File) {
    if (!file) {
      this.errorHandlerService.handle('No file to upload');

      return;
    }

    const extractedFileSize = Number(((file.size / 1024) / 1024).toFixed(2));

    // check file size
    if (extractedFileSize > this.maxFileSize) {
      this.errorHandlerService.handle(`You exceeded the max size of ${this.maxFileSize}MB`);

      return;
    }

    this.isUploading = true;
    this.projectService.uploadFile(file).subscribe((response: any) => {
      this.afterUpload.emit(response.file);
      this.isUploading = false;
    });
  }
}
